window.onscroll = function() {
    myFunction()
};
var header = document.getElementById("header");
var sticky = header.offsetTop;

function myFunction() {
  if (window.pageYOffset > sticky) {
	jQuery('body').addClass('sticky-header');
  } else {
	jQuery('body').removeClass('sticky-header');
  }
}

$slickGreen = false;
function greenSlider(){    
	if($(window).width() < 1200){
		if(!$slickGreen){
			$(".SlickCarousel").slick({
				arrows: false,
				slidesToShow: 2,
                slidesToScroll: 2,
                infinite: false,
                dots: true,
				responsive: [
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: true,
                      infinite: false
                    }
                  }
                ]
			})
			$slickGreen = true;
		}
	} else if($(window).width() >= 1200){
		if($slickGreen){
			$('.SlickCarousel').slick('unslick');
			$slickGreen = false;
		}
	}
};
                  
jQuery(window).on('resize', function(){
	greenSlider();
}); 

jQuery(document).ready(function($){
    jQuery("#insta-feed h2").html("SHOW US YOUR <span>#IMPLUSE</span>");
	jQuery(".slider").slick({
		dots: false,
		fade: false,
		pauseOnHover: false,
		arrows: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 13000,
		speed: 300,
		slidesToShow: 1,
		adaptiveHeight: true,
	});
	
	greenSlider();
	
	$(document).on('click', '.qtyplus', function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[id='+fieldName+']').val());
        console.log(currentVal);
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[id='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[id='+fieldName+']').val(0);
        }
    });
    // This button will decrement the value till 0
    $(document).on('click', '.qtyminus', function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[id='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[id='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[id='+fieldName+']').val(0);
        }
    });
	
	jQuery('.search__submit').click(function(){
		if(jQuery('form.search').hasClass('open-searc')){
			jQuery('form.search').removeClass('open-searc');
			jQuery('form.search').submit();
		} else {
			jQuery('form.search').addClass('open-searc');
			return false;
		}
	});
   
   // Product Gallery
   $('.product-gallery-wrapper').slick({
      slidesToShow: 9,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: false,
      prevArrow: false,
      nextArrow: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        }
  	  ]
   });
   // As seen slider
   $('.as-seen-wrapper .logos-wrapper').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow:"<img class='prev slick-prev' src='https://cdn.shopify.com/s/files/1/0617/7681/t/138/assets/prev-arrow-new.png?v=1641110578'>",
      nextArrow:"<img class='next slick-next' src='https://cdn.shopify.com/s/files/1/0617/7681/t/138/assets/next-arrow-new.png?v=1641110589'>",
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            autoplay: true,
  			autoplaySpeed: 2000
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            autoplay: true,
  			autoplaySpeed: 2000
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            autoplay: true,
  			autoplaySpeed: 2000
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            autoplay: true,
  			autoplaySpeed: 2000
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            autoplay: true,
  			autoplaySpeed: 2000
          }
        }
  	  ]
   });
   document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
  });
  // Menu Open
  $(".header-bottom .menu-icon").click(function(){
    $("body").toggleClass("menu-open");
  });
  //Announcment Slider
  $('.header-top .header-top-wrapper').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    arrows: false,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  // Main Products slider
   $('.main-products-slider-section .main-products-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      arrows: true,
      prevArrow:"<img class='prev slick-prev' src='https://cdn.shopify.com/s/files/1/0617/7681/files/left-arrow-thin.png?v=1662050241'>",
      nextArrow:"<img class='next slick-next' src='https://cdn.shopify.com/s/files/1/0617/7681/files/right-arrow-thin.png?v=1662050241'>",
   });
   // Features slider
   $('.features-slider-section .features-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      arrows: true,
      prevArrow:"<img class='prev slick-prev' src='https://cdn.shopify.com/s/files/1/0617/7681/files/left-arrow-thin.png?v=1662050241'>",
      nextArrow:"<img class='next slick-next' src='https://cdn.shopify.com/s/files/1/0617/7681/files/right-arrow-thin.png?v=1662050241'>",
      adaptiveHeight: true
   });
   // Match Height
   setTimeout(function () {
      var maxHeight = Math.max.apply(null, jQuery(".seller-box .first-box").map(function () {
          return jQuery(this).outerHeight();
        }).get());
        jQuery('.seller-box .first-box').css('min-height', maxHeight + 'px');

        var maxHeight = Math.max.apply(null, jQuery(".first-box .image-product").map(function () {
          return jQuery(this).outerHeight();
        }).get());
        jQuery('.first-box .image-product').css('min-height', maxHeight + 'px');
        
        var maxHeight = Math.max.apply(null, jQuery(".first-box h3").map(function () {
          return jQuery(this).outerHeight();
        }).get());
        jQuery('.first-box h3').css('min-height', maxHeight + 'px');
    	
    }, 200);
    
    jQuery(window).on('resize', function () {
        setTimeout(function () {
    		  var maxHeight = Math.max.apply(null, jQuery(".seller-box .first-box").map(function () {
            return jQuery(this).outerHeight();
          }).get());
          jQuery('.seller-box .first-box').css('min-height', maxHeight + 'px');

          var maxHeight = Math.max.apply(null, jQuery(".first-box .image-product").map(function () {
            return jQuery(this).outerHeight();
          }).get());
          jQuery('.first-box .image-product').css('min-height', maxHeight + 'px');
          
          var maxHeight = Math.max.apply(null, jQuery(".first-box h3").map(function () {
            return jQuery(this).outerHeight();
          }).get());
          jQuery('.first-box h3').css('min-height', maxHeight + 'px');
        }, 200);
    });
    $('.product-main-images').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        asNavFor: '.product-thumbnail-images'
    });
    $('.product-thumbnail-images').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.product-main-images',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        infinite: true,
        arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0617/7681/files/left-arrow.svg?v=1663238726' /></button>",
        nextArrow:"<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0617/7681/files/right-arrow.svg?v=1663238726' /></button>"
    });
	
    let title = document.querySelectorAll(".naviation-menu.navbar-expand-lg .navbar-nav .nav-item .plus-menu");

    title.forEach((qsitem) => {
      qsitem.addEventListener("click", function (e) {
        //   store the .answer div containing the answer
        let sibling = qsitem.nextElementSibling;
    
        // Nested loop for removing active class from all and set answer height to 0
        title.forEach((item) => {
          item.nextElementSibling.style.height = "0px";
          //   remove class "active" except for the currently clicked item
          item != qsitem && item.parentNode.classList.remove("active");
        });
        //then toggle the "active" class of clicked item's parent ".qna"
        this.parentNode.classList.toggle("active");
    
        // set actual height for .answer div if .qna has the class "active"
        if (qsitem.parentNode.classList.contains("active")) {
          sibling.style.height = sibling.scrollHeight + "px";
        } else {
          sibling.style.height = "0px";
        }
      });
    });
 
    let title_one = document.querySelectorAll(".faq-title");

    title_one.forEach((qsitem) => {
      qsitem.addEventListener("click", function (e) {
        //   store the .answer div containing the answer
        let sibling = qsitem.nextElementSibling;
    
        // Nested loop for removing active class from all and set answer height to 0
        title_one.forEach((item) => {
          item.nextElementSibling.style.height = "0px";
          //   remove class "active" except for the currently clicked item
          item != qsitem && item.parentNode.classList.remove("active");
        });
        //then toggle the "active" class of clicked item's parent ".qna"
        this.parentNode.classList.toggle("active");
    
        // set actual height for .answer div if .qna has the class "active"
        if (qsitem.parentNode.classList.contains("active")) {
          sibling.style.height = sibling.scrollHeight + "px";
        } else {
          sibling.style.height = "0px";
        }
      });
    });

    jQuery('.seller-box .first-box .title-product h3').each(function(){
      var me = $(this);
      me.html( me.text().replace(/(^\w+)/,'<span>$1</span>') );
    });
    setTimeout(function () {
      jQuery(".recommendation-wrapper").slick({
          arrows: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                infinite: true
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
                infinite: false
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                infinite: false
              }
            }
          ]
     });
    },1000);

   // Product Gallery
   $('.our-partners-section .slider-wrapper').slick({
      slidesToShow: 10,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 1,
      speed: 6000,
      dots: false,
      prevArrow: false,
      nextArrow: false,
      cssEase: 'linear',
      waitForAnimate: false,
      pauseOnFocus: false, 
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        }
  	  ]
   });
});


